import {
  Directive,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  NgZone,
} from '@angular/core';
import { zip } from 'rxjs';
import { PathOverlayOptions, AMapPathOverlay } from '../../base/amap-path-overlay';
import { AmapPolylineService } from './amap-polyline.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { EventBinderService } from '../../shared/event-binder.service';
import { getOptions, ChangeFilter } from '../../utils';

const TAG = 'amap-polyline';
const PolylineOptions = [
  ...PathOverlayOptions,
  'isOutline',
  'outlineColor',
  'geodesic',
  'dirColor',
  'borderWeight',
  'showDir',
  'path',
];

@Directive({
  selector: 'amap-polyline',
  exportAs: 'polyline',
  providers: [AmapPolylineService],
})
export class AmapPolylineDirective extends AMapPathOverlay<AMap.Polyline>
  implements OnChanges, OnDestroy {
  // ---- Options ----
  /**
   * çº¿æ¡æ¯å¦å¸¦æè¾¹
   */
  @Input() isOutline: boolean;
  /**
   * çº¿æ¡æè¾¹é¢è²
   */
  @Input() outlineColor: string;
  /**
   * æ¯å¦ç»å¶æå¤§å°çº¿
   */
  @Input() geodesic: boolean;
  /**
   * æ¹åç®­å¤´é¢è²
   */
  @Input() dirColor: string;
  /**
   * æè¾¹çå®½åº¦
   */
  @Input() borderWeight: number;
  /**
   * æ¯å¦å»¶è·¯å¾æ¾ç¤ºæ¹åç®­å¤´
   */
  @Input() showDir: boolean;
  /**
   * æçº¿çèç¹æ°ç»
   */
  @Input() path: AMap.LocationValue[];
  /**
   * é¢å¤: æ¯å¦éè
   */
  @Input() hidden = false;
  /**
   * é¢å¤: æ¯å¦å¼å¯ç¼è¾å¨
   */
  @Input() editor = false;
  /**
   * é¢å¤: ä¼è¦çå¶ä»å±æ§çéç½®æ¹å¼
   */
  @Input() options: AMap.Polyline.Options;

  // directive events:
  @Output() naReady = new EventEmitter();

  // editor events:
  @Output() naEditorAddNode: EventEmitter<any>;
  @Output() naEditorRemoveNode: EventEmitter<any>;
  @Output() naEditorAdjust: EventEmitter<any>;
  @Output() naEditorEnd: EventEmitter<any>;

  private inited = false;

  constructor(
    protected os: AmapPolylineService,
    protected binder: EventBinderService,
    private logger: LoggerService,
    private ngZone: NgZone,
  ) {
    super(os, binder);
    const editor = this.os.getEditor();
    this.naEditorAddNode = this.binder.bindEvent(editor, 'addnode');
    this.naEditorRemoveNode = this.binder.bindEvent(editor, 'removenode');
    this.naEditorAdjust = this.binder.bindEvent(editor, 'adjust');
    this.naEditorEnd = this.binder.bindEvent(editor, 'end');
  }

  ngOnDestroy() {
    this.os.destroy();
  }

  ngOnChanges(changes: SimpleChanges) {
    const filter = ChangeFilter.of(changes);
    const polyline = this.get();
    if (!this.inited) {
      this.logger.d(TAG, 'initializing ...');
      const options = this.options || getOptions<AMap.Polyline.Options>(this, PolylineOptions);
      this.logger.d(TAG, 'options:', options);
      this.os.create(options).subscribe(m => {
        this.ngZone.run(() => this.naReady.emit(m));
        this.logger.d(TAG, 'polyline is ready.');
      });
      this.inited = true;
    } else {
      zip(filter.has<AMap.LocationValue[]>('path'), polyline).subscribe(([v, p]) => p.setPath(v));
      zip(filter.has<AMap.Polyline.Options>('options'), polyline).subscribe(([v, p]) =>
        p.setOptions(v || {}),
      );
      zip(filter.has<any>('extData'), polyline).subscribe(([v, p]) => p.setExtData(v));
    }

    zip(filter.has<boolean>('hidden'), polyline).subscribe(([v, p]) => (v ? p.hide() : p.show()));
    filter.has<boolean>('editor').subscribe(v => this.os.toggleEditor(v));
  }

  /**
   * è·åå·²åå»ºç AMap.Polyline å¯¹è±¡
   */
  get() {
    return this.os.get();
  }
}
